import { AfterViewInit, Component, OnInit } from '@angular/core';
import { LoadscreenService, ToastService, DataService } from '@core/services';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { APIClient } from 'src/app/modules/_services/api/@generated';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-finalpayment-juncture',
  templateUrl: './finalpayment-juncture.component.html',
  styleUrls: ['./finalpayment-juncture.component.scss'],
  standalone: false
})
export class FinalpaymentJunctureComponent implements OnInit, AfterViewInit {
  faCreditCard = faCreditCard;
  _dataLocation: string;
  _insuranceFee: number;

  constructor(public LoadscreenService: LoadscreenService, public ToastService: ToastService, public DataService: DataService, private api: APIClient,
              private translate: TranslateService) { }

  ngAfterViewInit(): void {
    window.scrollTo(0, this.DataService.fixInfoContainerHeight + 505 + (this.DataService.isPartneri() ? 65 : 0) + (this.DataService.isKompakt() ? 0 : 60));
  }

  ngOnInit(): void {
    switch(Number(this.DataService.HIPInsuredPersonFromHIPDto.paymentFrequency)) {
      case 1:
        this._insuranceFee = this.DataService.HIPInsuredPersonFromHIPDto.insuranceFee.annualFee;
        break;
      case 2:
        this._insuranceFee = this.DataService.HIPInsuredPersonFromHIPDto.insuranceFee.semiAnnualFee;
        break;
      case 4:
        this._insuranceFee = this.DataService.HIPInsuredPersonFromHIPDto.insuranceFee.quarterlyFee;
        break;
      case 12:
        this._insuranceFee = this.DataService.HIPInsuredPersonFromHIPDto.insuranceFee.monthlyFee;
        break;
    }
  }

  formatCurrency(price: any) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  startOnlinePayment() {
    this.LoadscreenService.initiateLoading(this.translate.instant('junctures.finalPayment.pleaseWait'));

    this.api.saveInsuredPersonFromHip({insuredPerson: this.DataService.HIPInsuredPersonFromHIPDto}).subscribe(response => {
      this.DataService.HIPInsuredPersonFromHIPDto.id = response.id;
      this.payProcess();
    }, error => {
      this.LoadscreenService.cancelLoading();
      this.ToastService.initializeMessage(error.error.validationErrors[0].errorMessage, 'error');
    });
  }

  payProcess() {
    this.LoadscreenService.initiateLoading(this.translate.instant('junctures.finalPayment.pleaseWait'));

    this.api.payInsuredPersonFromHip({insuredPersonFromHIPId: this.DataService.HIPInsuredPersonFromHIPDto.id}).subscribe(response => {
      this.LoadscreenService.cancelLoading();
      window.location.href = response['response'];
    }, error => {
      this.LoadscreenService.cancelLoading();
      this.ToastService.initializeMessage(error.error.validationErrors[0].errorMessage, 'error');
    });
  }
}
